module.exports = __webpack_public_path__ + "img/google-icon.53a94e53.svg";